import React from 'react';
import { Shield, Award, Clock, CheckCircle } from 'lucide-react';

const Features = () => {
  return (
    <section className="features">
      <div className="container">
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">
              <Shield size={32} />
            </div>
            <h3>Fully Insured</h3>
            <p>Insured professionals committed to safety and quality</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">
              <Award size={32} />
            </div>
            <h3>6 Year Warranty</h3>
            <p>Comprehensive 6-year workmanship warranty on all our services</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">
              <Clock size={32} />
            </div>
            <h3>Emergency Services</h3>
            <p>Emergency services for storm damage</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">
              <CheckCircle size={32} />
            </div>
            <h3>Best Prices</h3>
            <p>Quality workmanship at competitive prices you can afford</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;